<template>
  <div class="my-order" ref="container" style="padding-top: 1rem;">
    <navTitle
      v-bind:isback="false"
      title="ODD OR EVEN"
      color="#4CADB5"
      font="#fff"
    ></navTitle>

    <div class="game">
      <div class="shadow"></div>
      <div class="game_content">
        <div class="game_title">Select your anticipated result</div>
        <div class="game_number_wrap">
          <div
            class="number_item"
            :class="0 === selectIndex ? 'click' : ''"
            @click="selectNumber(0, 1)"
          >
            Odd number
          </div>
          <div
            class="number_item"
            :class="1 === selectIndex ? 'click' : ''"
            @click="selectNumber(1, 0)"
          >
            Even number
          </div>
        </div>
        <div class="game_footer">
          <button class="submit" @click="submit">Confirm selection</button>
        </div>
      </div>
    </div>

    <!--<div class="game">-->
    <!--<div class="selectItemWrap">-->
    <!--<div class="selectItem">-->
    <!--<img v-show="select!=1" @click="handleSelect(1)" src="../../../assets/images/dan.png" alt="">-->
    <!--<img  v-show="select==1" src="../../../assets/images/danA.png" alt="">-->
    <!--</div>-->
    <!--<div class="selectItem">-->
    <!--<img  v-show="select!=0"  @click="handleSelect(0)"  src="../../../assets/images/shuang.png" alt="">-->
    <!--<img  v-show="select==0" src="../../../assets/images/shuangA.png" alt="">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <gameTable :list="list"></gameTable>

    <div class="list">
      <div class="top">
        <div class="navitem">Opening time</div>
        <div class="navitem">Issue</div>
        <div class="navitem">Number</div>
        <div class="navitem">Results</div>
      </div>
      <div class="live">
        <div class="ul" v-for="item in list">
          <div class="li">{{ item.time }}</div>
          <div class="li">{{ item.serial }}</div>
          <div class="li">{{ item.number }}</div>
          <div class="li">
            <span>{{ item.result }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { guessOddList, saveOrder } from "@api/game";
import gameTable from "@components/GameTable";

import navTitle from "@components/navTitle";
import { MessageBox } from "mint-ui";
const NAME = "game";
export default {
  name: NAME,
  data() {
    return {
      select: 2,
      id: "",
      selectIndex: "",
      selectNum: "",
      list: [
        // {
        //   time:'01-22 22:40',
        //   serial:'1',   //期号
        //   number:"2564", //开奖号码
        //   result:'偶数'
        // }
      ]
    };
  },
  components: {
    navTitle,
    MessageBox,
    gameTable
  },

  watch: {
    $route(query) {}
  },
  methods: {
    getList() {
      guessOddList({
        page: 1,
        limit: 50
      }).then(res => {
        // console.log('list',res)
        this.list = res.data;
      });
    },
    selectNumber(index, title) {
      this.selectIndex = index;
      this.selectNum = title;
      this.select = title;
    },

    submit() {
      if (!this.id) {
        this.$dialog.error("error:order_id is not exist!");
        return;
      }
      if(this.selectNum===""){
        return this.$dialog.error("Please choose  at least one!");
      }
      this.$dialog.loading.open("loading");
      saveOrder({
        order_id: this.id,
        guess: this.selectNum
      })
        .then(res => {
          // console.log('submit',res)
          this.$dialog.loading.close();

          MessageBox.confirm("", {
            closeOnClickModal: false,
            title: res.status == 200 ? "success" : "error",
            message: res.msg,
            showCancelButton: false,
            confirmButtonText: "Confirm"
          }).then(action => {
            return this.$router.replace({
              path: "/order/detail/" + this.id
            });
          });
        })
        .catch(res => {
          this.$dialog.loading.close();

          MessageBox.confirm("", {
            closeOnClickModal: false,
            title: res.status == 200 ? "success" : "error",
            message: res.msg,
            showCancelButton: false,
            confirmButtonText: "Confirm"
          }).then(action => {
            return this.$router.replace({
              path: "/order/detail/" + this.id
            });
          });
        });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    handleSelect(item) {
      MessageBox.confirm("", {
        closeOnClickModal: false,
        title: "message",
        message: "Are you sure select this one?",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "cancel"
      }).then(action => {
        this.select = item;
        this.submit(item);
      });
    }
  },
  mounted() {
    this.id = this.getQueryVariable("id");
    this.getList();
  }
};
</script>

<style scoped>
.game {
  width: 100%;
  height: 9rem;
  background: url("../../../assets/images/game_number_bg.svg") repeat;
  background-size: 30%;
  position: relative;
}
.shadow {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
}
.game_content {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0px;
  left: 0px;
}
.game_title {
  width: 100%;
  line-height: 0.8rem;
  height: 0.8rem;
  text-align: center;
  font-size: 0.38rem;
  color: #24396b;
  margin-top: 1.6rem;
  margin-bottom: 1rem;
}
.game_number_wrap {
  width: 6.6rem;
  margin: 0 auto 0.6rem auto;

  display: flex;
  justify-content: space-around;
  /*padding: 0 0.3rem;*/
  box-sizing: border-box;
}
.game_number_wrap .number_item {
  width: 2.15rem;
  /*flex: 1;*/

  height: 160px;
  padding: 50px 0;
  box-sizing: border-box;
  /*line-height:160px;*/
  font-size: 0.45rem;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  background: #fac94f;
  color: #fff;
  border: 2px solid #e49608;
  text-align: center;
  text-shadow: 2px 2px 2px #e49608;
  display: inline-block;
}
.game_number_wrap .number_item:nth-child(5n) {
  margin-right: 0px;
}

.game_number_wrap .number_item:last-child {
  margin-right: 0px;
}
.game_number_wrap .click {
  color: #395ba9;
  background: #fac94f;
  border: 2px solid #e49608;
  text-shadow: 2px 2px 2px #e49608;
}
.game_footer {
  width: 100%;
}
.list {
  width: 100%;
  margin: 0;
}
.list .top {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  display: flex;
  background: #ff4141;
}
.list .top .navitem {
  width: 25%;
  color: #fff;
  position: relative;
  text-align: center;
}
.list .top .navitem::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 50%;
  background: #fff;
}
.list .top .navitem:first-child:before {
  content: "";
  background: none;
}
.live {
  width: 100%;
  background: #fff;
}
.live .ul {
  width: 100%;
  height: 0.75rem;
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  line-height: 0.75rem;
  color: #333;
}
.live .li {
  width: 25%;
  text-align: center;
}
.live .li span {
  /*padding: 0.1rem 0.2rem;*/
  border-radius: 0.15rem;
  background: #00c3f9;
  color: #fff;
  width: 1.6rem;
  height: 0.55rem;
  display: block;
  margin: 0.1rem auto;
  line-height: 0.55rem;
}
.submitgame {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.2rem;
  width: 1.2rem;
  height: 0.6rem;
  line-height: 0.6rem;
  color: #ffeaa2;
  text-align: center;
  background: #ff4141;
  border-radius: 0.05rem;
}
.game_footer {
  width: 100%;
}
.submit {
  width: 2.9rem;
  height: 0.8rem;
  box-shadow: 2px 2px 5px #ccc;
  text-align: center;
  color: #fff;
  background: #fac94f;
  border-radius: 3px;
  margin: 0 auto;
  display: block;
  border: 2px solid #e49608;
  font-size: 0.36rem;
  animation: mymove 5s infinite;
  -webkit-animation: mymove 5s infinite;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
}

@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}
</style>
